<template>
  <div>
    <form v-on:submit="saveSalary" v-if="showgrid == 'hide'">
      <div class="card card-info">
        <div class="card-header with-border">
          <h3 class="card-title">
            New
          </h3>
        </div>
        <div class="card-body">
          <div class="row" style="margin-top: 7px">
            <div class="col-md-6">
              <label>Employee </label>
              <select class="form-control" v-model="obj.EmployeeID" v-on:change="employeeChange()">
                <option>--Select Employee--</option>
                <option v-for="item in Employees" :value="item.EmployeeRegistrationID">{{item.Name}}</option>
              </select>
            </div>

            <div class="col-md-6">
              <label>Appointment </label>
              <select class="form-control" v-model="obj.EmployeeAppointmentID" v-on:change="appointmentChange()" required>
                <option>--Select Appointment--</option>
                <option v-for="item in Appointment" :value="item.EmployeeAppointmentID">{{item.Name}}</option>
              </select>
            </div>

            <div class="col-md-6">
              <label>Wage Type* </label>
              <select class="form-control" v-model="obj.Wage" required>
                <option>--Select Type--</option>
                <option value="0">Monthly</option>
                <option value="1">Daily</option>
                <option value="2">Hourly</option>
              </select>
            </div>
            <div class="col-md-6">
              <label>Effective From* </label>
              <input class="form-control" type="date" v-model="obj.EffectiveFrom" required />
            </div>
            <div class="col-md-6">
              <label>HR Letter No* </label>
              <input class="form-control" type="text" v-model="obj.HRLetterNo" required />
            </div>
            <div class="col-md-6">
              <label>Letter Date* </label>
              <input class="form-control" type="date" v-model="obj.HRLetterDate" required />
            </div>

            <div class="col-md-6">
              <label>Salary Template(Optional) </label>
              <select class="form-control" v-model="obj.SalaryTemplateID" v-on:change="templateChange()">
                <option>--Select Template--</option>
                <option v-for="item in Templates" :value="item.SalaryTemplateID">{{item.Name}}</option>
              </select>
            </div>
          </div>
          <div class="row" style="margin-top:12px" v-if="showtable === 'show'">
            <div class="col-md-6">
              <label>Allowences</label>
              <table class="table table-bordered table-color table-sm">
                <thead class="bg-info">
                  <tr>
                    <th style="width: 10%">Sr. #</th>
                    <th style="width: 60%">Name</th>
                    <th style="width: 10%">Basic</th>
                    <th style="width: 20%">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in EmployeeSalary.filter((x) => { return x.Type == 'Allowences'; })">
                    <td>{{ind + 1}}</td>
                    <td>{{item.Name}}</td>
                    <td style="align-content:center">
                      <input class="form-check" type="checkbox" v-model="item.IsBasic">
                    </td>
                    <td>
                      <input class="form-control" v-model="item.Amount" style="text-align:right" v-mask="'########'" v-on:change="getSum('Allowences')" />
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <th colspan="3" style="text-align: center">Total Allowences</th>
                    <th style="text-align: right">{{totalallowence.toLocaleString()}}</th>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="col-md-6">
              <label>Deductables</label>
              <table class="table table-bordered table-color table-sm" width="100%">
                <thead class="bg-info">
                  <tr>
                    <th style="width: 10%">Sr. #</th>
                    <th style="width: 60%">Name</th>
                    <th style="width: 10%">Basic</th>
                    <th style="width: 20%">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in  EmployeeSalary.filter((x) => { return x.Type == 'Deductables'; })">
                    <td>{{ind + 1}}</td>
                    <td>{{item.Name}}</td>
                    <td style="align-content:center">
                      <input class="form-check" type="checkbox" v-model="item.IsBasic">
                    </td>
                    <td>
                      <input class="form-control" v-model="item.Amount" style="text-align:right" v-mask="'########'" v-on:change="getSum('Deductables')" />
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <th colspan="3" style="text-align: center">Total Deductables</th>
                    <th style="text-align: right">{{totaldeductable.toLocaleString()}}</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="row" style="margin-top:12px" v-if="showtable === 'show'">
            <div class="col-6">

            </div>
            <div class="col-6">
              <p class="lead">Detail</p>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <!--<tr>
                      <th style="width:50%">Total Allowances:</th>
                      <td>{{totalallowence.toLocaleString()}}</td>
                    </tr>
                    <tr>
                      <th style="width:50%">Total deductable:</th>
                      <td>{{totaldeductable.toLocaleString()}}</td>
                    </tr>-->
                    <tr>
                      <th>Net Payable:</th>
                      <td>{{(totalallowence - totaldeductable).toLocaleString()}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="row float-right">
            <button class="btn btn-success" style="margin-right:5px" type="submit">Save</button>
            <button class="btn btn-danger" type="button" v-on:click="cancel()">Cancel</button>
          </div>
        </div>
      </div>
    </form>
    <div class="card card-info" v-if="showgrid == 'show'">
      <div class="card-header with-border">
        <h3 class="card-title">
          <button class=" float-left btn btn-sm btn-outline-secondary btn-default" v-on:click="addnew()"> <i class="fa fa-plus">Add New</i></button>
        </h3>
      </div>
      <div class="card-body">
        <div class="row" style="margin-top: 7px">
          <table class="table table-bordered table-sm text-sm" width="100%">
            <thead class="bg-info">
              <tr>
                <th>Sr. No.</th>
                <th>HR Letter No</th>
                <th>HR Letter Date</th>
                <th>Name</th>
                <th>Effective From</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, ind) in Details">
                <td>{{ind+1}}</td>
                <td>{{item.HRLetterNo}}</td>
                <td>{{item.HRLetterDate}}</td>
                <td>{{item.Name}}</td>
                <td>{{item.EffectiveFrom}}</td>
                <td>
                  <button class="btn btn-success" v-on:click="edit(item.EmployeeSalaryID)">Edit</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        obj: {
          EmployeeID: '',
          EmployeeAppointmentID: '',
          SalaryTemplateID: '',
          Wage: 0,
          EffectiveFrom: '',
        },
        Employees: [],
        Appointment: [],
        Templates: [],
        EmployeeSalary: [],
        Details: [],
        showtable: 'hide',
        totalallowence: 0,
        totaldeductable: 0,
        showgrid: 'show',
      }
    },
    created: function () {
    },
    mounted: function () {
      this.pageload();
    },
    updated: function () {
      $('#RecordTable').DataTable();
    },
    methods: {
      addnew() {
        this.showgrid = 'hide';
      },

      pageload() {
        var vm = this;
        axios.post('/api/PayrollApi/pageloadEmployeeSalary')
          .then(function (res) {
            if (res.data.status)
              vm.Employees = res.data.lst;
            vm.Templates = res.data.salaryTemp;
            vm.Details = res.data.data;
          })
      },

      employeeChange() {
        var vm = this;
        axios.post('/api/PayrollApi/employeeChange?ID=' + vm.obj.EmployeeID)
          .then(function (res) {
            if (res.data.status)
              vm.Appointment = res.data.lst;
          })
      },

      appointmentChange() {
        var vm = this;
        axios.post('/api/PayrollApi/appointmentChange?AppointmentID=' + vm.obj.EmployeeAppointmentID)
          .then(function (res) {
            if (res.data.status)
              vm.EmployeeSalary = res.data.head;
            vm.totalallowence = res.data.Allowences;
            vm.totaldeductable = res.data.Deductables;
            vm.showtable = 'show';
          })
      },

      getSum(cat) {
        this.totalallowence = 0;
        this.totaldeductable = 0;
        for (var i = 0; i < this.EmployeeSalary.length; i++) {
          if (this.EmployeeSalary[i].Type == 'Allowences') {
            this.totalallowence += Number(this.EmployeeSalary[i].Amount);
          }
          else {
            this.totaldeductable += Number(this.EmployeeSalary[i].Amount);
          }
        }

      },

      templateChange() {
        var vm = this;
        axios.post('/api/PayrollApi/templateChange?TempID=' + vm.obj.SalaryTemplateID)
          .then(function (res) {
            if (res.data.status)
              vm.EmployeeSalary = res.data.lst;
            vm.totalallowence = res.data.Allowences;
            vm.totaldeductable = res.data.Deductables;
            vm.showtable = 'show';
          })
      },

      saveSalary(e) {
        e.preventDefault();
        var vm = this;
        axios.post('/api/PayrollApi/saveSalary', {
          obj: vm.EmployeeSalary,
          master: vm.obj,
        })
          .then(function (res) {
            if (res.data.status) {
              toastr.success(res.data.msg);
              setTimeout(alertFunc, 2000);
            }
            else {
              toastr.success(res.data.msg);
            }
          })
      },

      edit(ID) {
        var vm = this;
        axios.post('/api/PayrollApi/Edit?ID=' + ID)
          .then(function (res) {
            if (res.data.status)
              axios.post('/api/PayrollApi/employeeChange?ID=' + res.data.master.EmployeeID)
                .then(function (res) {
                  if (res.data.status)
                    vm.Appointment = res.data.lst;
                })
            vm.obj = res.data.master;
            vm.EmployeeSalary = res.data.child;
            vm.totalallowence = res.data.Allowences;
            vm.totaldeductable = res.data.Deductables;
            vm.showgrid = 'hide';
            vm.showtable = 'show';
          })
      },

      cancel() {
        window.location.reload();
      },
    }
  })
  function alertFunc() {
    window.location.reload();
  }
</script>



// WEBPACK FOOTER //
// src/components/payroll/employeesalary.vue